import React from "react";
import CartsProduct from "../components/Carts/CartsProduct";
import Footer from "../components/HomePage/Footer";
import { useMediaQuery } from "react-responsive";
import MobileCarts from "../mobileComponent/MobileCartPage/MobileCarts";

function Carts() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 501px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 500px)" });
  return (
    <>
      {isDesktopOrLaptop && (
        <>
          <CartsProduct />
          <Footer />
        </>
      )}
      {isTabletOrMobile && (
          <MobileCarts />
      )}
    </>
  );
}

export default Carts;
